<template>
  <b-modal
      ref="modal"
      no-close-on-backdrop
      centered
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      :body-bg-variant="bodyBgVariant"
      :body-text-variant="bodyTextVariant"
      :footer-bg-variant="footerBgVariant"
      :footer-text-variant="footerTextVariant"
      :size="size"
      :id="modal.id"
      :title="modal.title"
      class="font-size-base"
      @hidden="resetInfoModal"
      scrollable
  >
    <div v-if="hasHeader" style="padding-bottom: 10px;">
      <span style="font-style: italic;">Τα κάτωθι 4 πεδία αφορούν στην ίδια ιδιότητα. </span>
    </div>
    <BaseBForm v-if="modal.id !=='delete-modal'" ref="form" :model="data" @isDisabled="toogleDisabled"
               @onChange="onChange"/>
    <div v-if="modal.id ==='delete-modal'"> Είστε σίγουροι ότι θέλετε να διαγράψετε την επιλεγμένη εγγραφή ;</div>
    <template #modal-footer="{ }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" :variant="modal.id === 'delete-modal' ? 'light': 'danger'" class="mr-2"
                @click="resetInfoModal">
        <p class="h8 mb-0">
          <b-icon-x-square class="pr-1"></b-icon-x-square>
          Ακύρωση
        </p>
      </b-button>
      <b-button v-if="modal.id !=='delete-modal'" id="modal-submit" size="sm" class="mr-2" variant="success"
                @click="onSubmit" :disabled="isDisabled" @onChange="onChange">
        <p class="h8 mb-0">
          <b-icon-check2-square class="pr-1"></b-icon-check2-square>
          Αποθήκευση
        </p>
      </b-button>
      <b-button v-if="modal.id ==='delete-modal'" id="modal-delete" size="sm" variant="danger" class="mr-2"
                @click="onDelete">
        <p class="h8 mb-0">
          <b-icon-trash class="pr-1"></b-icon-trash>
          Διαγραφή
        </p>
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import {PopupEnum} from "@/util/EnumUtil";
import {isEmpty} from "@/util/Helpers";

export default {
  name: "BaseBFormModal",
  props: {
    model: Object,
    hasHeader: {
      default: () => false,
      require: false,
      type: Boolean
    },
    size: {
      default: () => 'xl',
      require: false,
      type: String
    },
  },
  data() {
    return {
      isDisabled: false,
      variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
      headerTextVariant: 'white',
      bodyBgVariant: 'white',
      bodyTextVariant: 'dark',
      footerBgVariant: 'white',
      footerTextVariant: 'dark',
      modalData: {},
      currentIndex: -1,
      modal: {
        id: PopupEnum.EDIT.ID,
        title: 'Επεξεργασία',
        type: 'info'
      }
    }
  },

  computed: {
    data() {
      return this.modalData
    },
    headerBgVariant() {
      switch (this.modal.type) {
        case 'info':
          return 'info'
        case 'delete':
          return 'danger'
        default:
          return 'success'
      }
    }
  },
  methods: {
    toogleDisabled(ready) {
      this.isDisabled = !ready;
    },

    resetInfoModal() {
      // this.$nextTick(() => {
      if (!isEmpty(this.model.fields)) {
        this.model.fields.forEach(child => {
          if (Object.prototype.hasOwnProperty.call(child, 'warningMessage')) {
            child.warningMessage = []
          }
        })
      }
      this.$bvModal.hide(this.modal.id)
      this.modal = {...PopupEnum.UNSAVED_CHANGES}
      // })
    },

    openDeletePopUp(item, currentIndex) {
      this.currentIndex = currentIndex
      if (!isEmpty(this.model.model)) {
        this.modalData.form = {...this.model.model.form}
      } else {
        this.modalData.form = {...this.model.form}
      }

      if (!isEmpty(this.modalData.form)) {
        if (!isEmpty(item)) {
          this.modalData.form = {...item}
          this.modalData.fields = this.model.fields
          this.modalData.validations = {...this.model.validations}
        } else {
          this.modalData.form = null
        }
        this.modal = {...PopupEnum.DELETE}
        this.$nextTick(() => {
          this.$bvModal.show(this.modal.id)
        })
      }
    },
    openMultiDeletePopUp() {
      this.modal = {...PopupEnum.DELETE}
      this.$nextTick(() => {
        this.$bvModal.show(this.modal.id)
      })
    },
    onEdit(item, currentIndex) {
      console.log('onEdit-modal')
      this.currentIndex = currentIndex
      this.modalData.form = {...this.model.model.form}
      if (!isEmpty(this.modalData.form)) {
        this.modalData.form = {...item}
        this.modalData.fields = this.model.fields
        this.modalData.validations = {...this.model.validations}
        this.modal = {...PopupEnum.EDIT}
        this.$nextTick(() => {
          this.$bvModal.show(this.modal.id)
        })
      }
    },

    onCreate() {
      console.log('onCreate')
      this.currentIndex = -1
      this.modalData.form = {...this.model.model.form}
      this.modalData.fields = this.model.fields
      this.modalData.validations = {...this.model.validations}
      this.model.fields.forEach(row => {
        if (Object.prototype.hasOwnProperty.call(row, 'items')) {
          row.items = []
        }
      })
      this.modal = {...PopupEnum.CREATE}
      this.$nextTick(() => {
        this.$bvModal.show(this.modal.id)
      })
    },
    onSubmit() {
      console.log('onEdit-modal')

      let resultObject = {
        formResult: this.$refs.form.onSubmit(),
        modalId: this.modal.id,
        index: this.currentIndex,
      }
      this.$emit("handle-submit", resultObject);
    },

    onDelete() {
      this.$nextTick(() => {
        this.$bvModal.hide(this.modal.id)
      })

      let resultObject = {
        formResult: true,
        modalId: this.modal.id,
        index: this.currentIndex,
        record: this.modalData.form
      }
      // store.dispatch("isValid", {isValid: true, isUpdated: true})
      this.$emit("handle-delete", resultObject);
    },

    /* Fire only when e b-select change value*/
    onChange(item) {
      this.modalData.fields = item
    },

    onValid(item) {
      let result = {result: true, errors: []}
      try {
        if (!isEmpty(this.$refs.form)) {
          result = this.$refs.form.onValid(item)
          if (result.result) {
            // this.$nextTick(() => {
            this.$bvModal.hide(this.modal.id)
            // })
            this.$store.dispatch("hasUnsavedChanges", true);
            this.resetInfoModal()
          }
        }
        return result
      } catch (e) {
        console.log(e)
        return !result
      }
    },
  }
}
</script>

<style scoped>

</style>